module.exports = __webpack_public_path__ + "img/ALP_LGO.39560e0a.svg";